import React from 'react'
import moment from 'moment-timezone'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import {getTimeFormats, getDateFormats} from 'utils/utils'

class DateTimeFormat extends React.Component {
    constructor(props) {
        super(props)

        const {timeFormat, dateFormat} = this.getDateTimeFormat(props.format, props.type)
        this.dateFormats = getDateFormats()
        this.timeFormats = getTimeFormats()

        this.state = {
            dateFormat,
            timeFormat,
            type: props.type
        }
    }

    getDateTimeFormat(format, type) {
        let timeFormat, dateFormat
        if (type && format) {
            if (type === 'dateonly') {
                timeFormat = 'HH:mm'
                dateFormat = format
            } else {
                const index = format.indexOf('H') !== -1 ? format.indexOf('H') : format.indexOf('h')
                timeFormat = format.slice(index)
                dateFormat = format.slice(0, index - 1)
            }
        } else {
            timeFormat = 'HH:mm'
            dateFormat = 'DD MMMM YYYY'
        }

        return {timeFormat, dateFormat}
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, () => this.handleUpdate())
    }

    handleToggle = (e) => {
        this.setState({
            type: e.target.checked ? 'datetime' : 'dateonly'
        }, () => this.handleUpdate())
    }

    handleUpdate = () => {
        let format
        if (this.state.type === 'datetime') {
            format = this.state.dateFormat + ' ' + this.state.timeFormat
        } else {
            format = this.state.dateFormat
        }

        this.props.handleChange({dateType: this.state.type, format})
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <FormControl variant="standard"
					sx={{
						width: '100%',
        				marginBottom: '20px'
					}}
				>
                    <InputLabel shrink={true}>{intl.formatMessage({id: "config.date_format"})}</InputLabel>
                    <Select
                        value={this.state.dateFormat}
                        onChange={this.handleChange}
                        inputProps={{
                            name: 'dateFormat'
                        }}
                    >
                        {this.dateFormats.map((item, index) =>
                            <MenuItem key={index} value={item}>{moment().format(item)}</MenuItem>
                        )}
                    </Select>
                </FormControl>
                <FormControlLabel
                    sx={{
						width: '100%',
						marginRight: 0,
						marginBottom: '20px'
					}}
                    control={
                        <Checkbox
							sx={{
								padding: '0 9px'
							}}
                            checked={this.props.type === 'datetime' ? true : false}
                            onChange={this.handleToggle}
                            name='format'
                        />
                    }
                    label={intl.formatMessage({id: "config.date_include_time"})}
                />
                {this.props.type === 'datetime' &&
                    <FormControl variant="standard"
						sx={{
							width: '100%',
							marginBottom: '20px'
						}}
					>
                        <InputLabel shrink={true}>{intl.formatMessage({id: "config.date_time_format"})}</InputLabel>
                        <Select
                            value={this.state.timeFormat}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'timeFormat'
                            }}
                        >
                            {this.timeFormats.map((item, index) =>
                                <MenuItem key={index} value={item}>{moment().format(item)}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                }
            </React.Fragment>
        )
    }
}

export default injectIntl(DateTimeFormat)
